import { CollectionType } from "containers/folders/types/assortment";
import { ItemKind } from "containers/folders/types/base";
import { nameExtRemover } from "containers/folders/utils/space-item";

export const processAssortmentItem = (item, verticalAssortmentsEnabled = false) => {
    const { shortcut_facet, collection_facet } = item;

    const showErrorStyle =
        shortcut_facet?.target_item_deleted ||
        (verticalAssortmentsEnabled && collection_facet?.collection_type !== CollectionType.Vertical);

    const name = nameExtRemover(item.name, item.kind as ItemKind);
    const isDeleted = shortcut_facet?.target_item_deleted ?? false;

    return { key: item.id, name, showErrorStyle, isDeleted };
};
